// extracted by mini-css-extract-plugin
export var cell = "_6p-4";
export var headerCell = "_6p-2";
export var rowHeader = "_6p-3";
export var table = "_6p-1";
export var tableContainer = "_6p-0";